import React, {memo, useState} from "react";
import {Input, Row, Select} from "antd";
import styled from "styled-components";

const CallbackListItemComponent = ({defaultKey, value, setKey, setValue}) => {
    return (
        <div>
            <Grid>
                <Input
                    value={defaultKey}
                    onChange={e => {
                        setKey(e.target.value);
                    }}
                />
                <Select
                    value={value}
                    onChange={e => {
                        setValue(e);
                    }}
                >
                    <Select.Option value="orderNumber">Sipariş Numarası</Select.Option>
                    <Select.Option value="vigoOrderNumber">Vigo Order ID</Select.Option>
                    <Select.Option value="orderState">Sipariş Durumu</Select.Option>
                </Select>
            </Grid>
        </div>
    );
};

export const CallbackListItem = memo(CallbackListItemComponent);

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 10px;
    gap: 10px;
`;
